import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/api';

/**
 * Wrap a routed element so it only renders when a valid session exists.
 * If the user is unauthenticated we push them to ``/login`` while keeping
 * the intended destination in location state (so the login flow can bring
 * them back to the same URL after signing in).
 */
export default function PrivateRoute({ children }) {
    const location = useLocation();
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}
